import React from 'react'
import AllWorkReportList from '../components/AllWorkReportList'
import HRMSLayout from '../../../../../layout/components/HRMSLayout'

function WorkReportDashboardPage() {
  return (
    <HRMSLayout>
        <AllWorkReportList/>
    </HRMSLayout>
  )
}

export default WorkReportDashboardPage